module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/icon-prize-05-4702752f7472e2d6fed1bf67143adc1d.svg";